import React, { Component } from 'react';
import { Collapse } from 'react-collapse';
import { NavLink } from 'react-router-dom';

  export default class LocatedItemsList extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpened: true }
  }

  toggleCollapse = () => {
    this.setState({isOpened: !this.state.isOpened});
  };

  render(){
    return(
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center pointer" onClick={this.toggleCollapse}>
          <div className="d-flex">
            <h5 className="mr-05 mb-0">{this.props.title}</h5>
            {this.state.isOpened ? null : <span> ({this.props.inventories.length})</span> }
          </div>
          <i className={`fa ${this.state.isOpened ? "fa-caret-up" : "fa-caret-down"}`}></i>
        </div>
        <Collapse isOpened={this.state.isOpened}>
          <div className="card-block p-0 m-0">
            {this.props.inventories.length ?
              <table className="table table-striped table-hover mb-0">
                <thead>
                  <tr>
                    <th>Item Id</th>
                    <th className="hidden-xs-down">Item</th>
                    <th className="hidden-sm-down">Station</th>
                    <th className="hidden-xs-down">Current Location</th>
                    <th>Moving to</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.inventories.map((inventory,index)=>{
                    return(
                      <tr key={index}>
                        <td>
                          <NavLink className="ml-05" to={`/inventory/${inventory.id}`}>
                            {inventory.id}
                          </NavLink>
                        </td>
                        <td className="hidden-xs-down">{inventory.item.name}</td>
                        <td className="hidden-sm-down">{inventory.station.name}</td>
                        <td className="hidden-xs-down">{inventory.current_location ? inventory.current_location.name : '-'}</td>
                        <td>{inventory.new_location ? inventory.new_location.name : '-'}</td>
                        <td>
                          <span className="btn btn-danger btn-sm mr-0" onClick={() => this.props.onDelete(index)}><i className="fa fa-trash"></i></span>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            :
              <div className="empty-table"><span>No items yet</span></div>
            }

          </div>
        </Collapse>
      </div>
    )
  }
}
